module.exports = __webpack_public_path__ + "static/media/contact.a5b9fde6.jpg";